// extracted by mini-css-extract-plugin
module.exports = {"container":"main-header_container__2-Dzv","logo":"main-header_logo__27LOQ"};